import { BackupPolicyType } from '@repo/api-gw-sdk';

import { Tag } from '@/components/tag';

export const BackupPolicyTypeTag = ({
  policyType,
}: {
  policyType?: BackupPolicyType;
}) => {
  return policyType === BackupPolicyType.BACKUP_POLICY_TYPE_PITR ? (
    <Tag content='PiTR' variant='secondary' />
  ) : policyType === BackupPolicyType.BACKUP_POLICY_TYPE_HIGH_FREQUENCY ? (
    <Tag content='High-frequency' variant='secondary' />
  ) : null;
};
